import { render, staticRenderFns } from "./releasePush.vue?vue&type=template&id=bd7e95a6&scoped=true&"
import script from "./releasePush.vue?vue&type=script&lang=js&"
export * from "./releasePush.vue?vue&type=script&lang=js&"
import style0 from "./releasePush.vue?vue&type=style&index=0&id=bd7e95a6&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bd7e95a6",
  null
  
)

export default component.exports